var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-document-item-slot"},[(!!_vm.p_slot)?_c('link-slot',{attrs:{"slots":[_vm.p_slot]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }